<template>
  <div id="mountNode" :style="{width:width}">
    <div class="editor" >
      <toolbar ref="toolbarRef" v-if="sceneStatus === 0" @handleClick="clickEvent" @sendSceneStatus="setSceneStatus"/>
      <toolbarLock v-if="sceneStatus !== 0" @handleClick="clickEvent" @sendSceneStatus="setSceneStatus"/>
      <div style="height: 60px;"></div>
      <div class="bottom-container" :style="{height:'calc(100vh - 175px)'}" style="display: flex">
        <FlowChart v-if="sceneStatus === 0" ref="FlowChart" :style="isEnlarge ? 'display: none;' : ''" @sendAttr="getAttr" @clearNode="clearNode"/>
        <FlowChartLock v-if="sceneStatus !== 0" ref="FlowChart" :style="isEnlarge ? 'display: none;' : ''" @sendAttr="getAttr" @clearNode="clearNode"/>
        <div :style="isEnlarge ? 'width: 100%;' : 'width: 500px'" style="height: calc(100vh - 175px);border-left:2px solid #DDDDDD;background-color: #FFF; overflow-y: auto;">
          <div :style="isEnlarge ? 'height: calc(100vh - 178px);' : 'height: 40%'" style="position: relative;border-bottom: 2px solid #DDDDDD">
            <div style="float: right; position: absolute; right: 5px;top: 5px;">
              <i v-show="!isEnlarge" class="full-screen" @click="enlarge()"></i>
              <i v-show="isEnlarge" class="close-full-screen" @click="narrow()"></i>
            </div>
            <iframe id="receiver" loading="lazy" src="https://uspdeveloper.uaes.com/raydata/" style="width:100%;height: 100%;" frameborder="0" scrolling="no"></iframe>
          </div>
          <component
              :is="component"
              v-show="component"
              :style="isEnlarge ? 'display: none;' : ''"
              style="min-height: 410px; padding: 30px 0;color: #000;"
              :value="param"
              :name="name"
              :readonly="sceneStatus"
              @callBackJson="callBackJson"
          ></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Toolbar from '../../../components/Toolbar'
import ToolbarLock from '../../../components/ToolbarLock'
import FlowChart from './FlowChart'
import FlowChartLock from './FlowChartLock'

export default {
  name: 'G6Index',
  components: {
    attr1: resolve => require([`@/components/atomicServiceAttrWindow/attr1/index`], resolve),
    attr2: resolve => require([`@/components/atomicServiceAttrWindow/attr2/index`], resolve),
    attr3: resolve => require([`@/components/atomicServiceAttrWindow/attr3/index`], resolve),
    attr4: resolve => require([`@/components/atomicServiceAttrWindow/attr4/index`], resolve),
    attr5: resolve => require([`@/components/atomicServiceAttrWindow/attr5/index`], resolve),
    attr6: resolve => require([`@/components/atomicServiceAttrWindow/attr6/index`], resolve),
    attr7: resolve => require([`@/components/atomicServiceAttrWindow/attr7/index`], resolve),
    attr8: resolve => require([`@/components/atomicServiceAttrWindow/attr8/index`], resolve),
    attr9: resolve => require([`@/components/atomicServiceAttrWindow/attr9/index`], resolve),
    attr10: resolve => require([`@/components/atomicServiceAttrWindow/attr10/index`], resolve),
    attr11: resolve => require([`@/components/atomicServiceAttrWindow/attr11/index`], resolve),
    attr12: resolve => require([`@/components/atomicServiceAttrWindow/attr12/index`], resolve),
    Toolbar,
    FlowChart,
    FlowChartLock,
    ToolbarLock
  },
  props: {
    height: {
      type: Number,
      default: document.documentElement.clientHeight
    },
    width: {
      type: Number,
      default: document.documentElement.clientWidth
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    console.log('监听')
    window.addEventListener('RunClass', event => {
      console.log(event)
    })
  },
  data() {
    return {
      host: location.hostname === 'localhost' ? 'https://usp-test.uaes.com' : '',
      editor: {},
      command: null,
      isEnlarge: false,
      attr: '',
      component: null,
      serve: null,
      param: '',
      name: '',
      sceneStatus: 0,
      value: {
        'totalTime': 12.0,
        'timeLineDatas': [
          {
            'timeLine': 2.0,
            'name': 'RearviewMirrorDefrosting',
            'operateStr': '{\'operateType\':0}'
          },
          {
            'timeLine': 12.0,
            'name': 'RearviewMirrorDefrosting',
            'operateStr': '{\'operateType\':1}'
          }
        ]
      }
    }
  },
  created() {
    this.init()
  },
  beforeDestroy() {
    this.stopAutoSave()
  },
  methods: {
    clearNode() {
      this.component = ''
    },
    getAttr(data) {
      if (data) {
        console.log(1, data)
        this.serve = data
        this.name = data.properties.name
        this.param = data.properties.operateStr ? data.properties.operateStr : ''
        this.component = data.properties.attribute
      }
    },
    callBackJson(value) {
      // this.clearNode()
      this.serve.properties.operateStr = value.data
      this.serve.text.value = value.nameText
      // this.param = value.data
      this.$refs.FlowChart.getNewServe(this.serve)
    },
    init() {
      console.log('入门级场景开始')
      window.addEventListener('message', (e) => {
        try {
          console.log('postMessage data', e)
          if (e.data.runningCode) {
            if (e.data.runningCode === '1001' || e.data.runningCode === '1002' || e.data.runningCode === '1003') {
              this.alertMessage(e.data.message)
            }
          }
        }
        catch (error) {
          console.log('error', error)
        }
      })
    },
    enlarge() {
      this.isEnlarge = true
    },
    narrow() {
      this.isEnlarge = false
    },
    clickEvent(data) {
      this.$message({
        message: '数据发送中',
        type: 'success'
      })
      var receiver = document.getElementById('receiver').contentWindow
      console.log('data', data)
      var val = data
      receiver.postMessage(val, 'https://uspdeveloper.uaes.com/raydata/')
    },
    setSceneStatus(val) {
      if (val === 4) {
        this.sceneStatus = 0
      }
      else if (val === 3) {
        this.sceneStatus = 1
      }
      else {
        this.sceneStatus = val
      }
      this.$refs.toolbarRef.setSaveTimer(val)
    },
    stopAutoSave() {
      if (this.sceneStatus === 0) {
        this.$refs.toolbarRef.setSaveTimer(1)
      }
    },
    alertMessage(msg) {
      this.$message({
        message: msg,
        type: 'warning'
      })
    }
  }
}
</script>

<style scoped>
.editor {
  position: relative;
  width: 100%;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.bottom-container {
  position: relative;
}
/deep/ .lf-control {
  margin-top: 25px !important;
}
/deep/ .lf-control-zoomOut {
    background-image: url(https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/customize/scene_toolBar_zoomOut.png) !important;
}
/deep/ .lf-control-zoomIn {
    background-image: url(https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/customize/scene_toolBar_zoomIn.png) !important;
}
/deep/ .lf-control-fit {
    background-image: url(https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/customize/scene_toolBar_fit.png);
}
/deep/ .lf-control-undo {
    background-image: url(https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/customize/scene_toolBar_back.png);
}

/deep/ .lf-control-redo {
  background-image: url(https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/customize/scene_toolBar_forward.png);
}
.full-screen {
  width: 20px;
  height: 20px;
  display: inline-block;
  margin: 10px;
  cursor: pointer;
  background-image: url(https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/customize/scene_full-screen.png);
}
.close-full-screen {
  width: 20px;
  height: 20px;
  display: inline-block;
  margin: 10px;
  cursor: pointer;
  background-image: url(https://test-biz-pub-1314150920.cos.ap-shanghai.myqcloud.com/web/customize/scene_reduce-screen.png);
}
</style>
